import { render, staticRenderFns } from "./information.vue?vue&type=template&id=5342671a&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=5342671a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342671a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5342671a')) {
      api.createRecord('5342671a', component.options)
    } else {
      api.reload('5342671a', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=5342671a&scoped=true", function () {
      api.rerender('5342671a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffCustomerManage/staffForm/information.vue"
export default component.exports